import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SearchBrand = () => {

    let query = useQuery();
    const { t } = useTranslation('search');

    const getSearchBrands = useSelector((state) => state.getSearchBrands);
    return (
        <div>
            {getSearchBrands.length > 0 ? (
                <ul className="menu-items">
                    {getSearchBrands.map((item, key) => (
                        <Link className="brand-main-no-sub" to={query.get("category") ? `?q=${query.get("q")}&category=${query.get("category")}&brand=${item}` : `?q=${query.get("q")}&brand=${item}`}>
                            <li className="brand-menu-item" >{item.replace(" 1****", "")}</li>
                        </Link>
                    ))}
                </ul>
            ) : <h5>{t('nemaRezultata')}</h5>}
        </div>
    );
};

export default SearchBrand;